module.exports = __webpack_public_path__ + "img/scene2.ad1dd849.svg";